import { Star } from 'lucide-react';

import { Card, CardContent } from '@/components/ui/card';
import { landingContent } from '@/constants/landing-content';

const { testimonials } = landingContent;

export function TestimonialsSection() {
  return (
    <section id={testimonials.id} className="py-16 md:py-24">
      <div className="container mx-auto max-w-6xl px-4">
        <h2 className="text-foreground text-center text-3xl font-bold tracking-tight md:text-4xl">
          {testimonials.headline}
        </h2>

        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {testimonials.items.map((item, index) => (
            <Card key={index} className="border-none shadow-sm">
              <CardContent className="pt-6">
                <div className="flex items-center gap-4">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="h-12 w-12 rounded-full object-cover"
                  />
                  <div>
                    <p className="text-foreground font-medium">{item.name}</p>
                    <p className="text-muted-foreground text-sm">
                      {item.context}
                    </p>
                  </div>
                </div>

                <div className="mt-3 flex gap-0.5">
                  {Array.from({ length: item.rating }).map((_, i) => (
                    <Star
                      key={i}
                      className="h-4 w-4 fill-yellow-400 text-yellow-400"
                    />
                  ))}
                </div>

                <blockquote className="text-muted-foreground mt-4 text-sm leading-relaxed">
                  "{item.quote}"
                </blockquote>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
